module.exports = __webpack_public_path__ + "static/media/Inter-Black.b412a8d7.ttf";